import { useState } from "react";
import { Drawer } from "@mui/material";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { X } from "lucide-react";

import { Allergies } from "components/PatientDetailCardWithOverview/components/PatientOverviewModal/components/Allergies/Allergies";
import { Consultations } from "components/PatientDetailCardWithOverview/components/PatientOverviewModal/components/Consultations/Consultations";
import { MedicalHistory } from "components/PatientDetailCardWithOverview/components/PatientOverviewModal/components/MedicalHistory/MedicalHistory";
import { Medications } from "components/PatientDetailCardWithOverview/components/PatientOverviewModal/components/Medications/Medications";

import styles from "./PatientOverviewDrawer.module.css";

export const PatientOverviewDrawer = ({ open, onClose }) => {
  const [tab, setTab] = useState("medicalHistory");

  return (
    <Drawer open={open} onClose={onClose} anchor={"right"}>
      <div className={styles.drawerHeader}>
        <div className={styles.headerTitle}>
          <h2>Patient overview</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>
        <div className={styles.content}>
          <ToggleButtonGroup
            value={tab}
            exclusive
            onChange={(e) => setTab(e.target.value)}
            aria-label="patient overview navigation"
            className={styles.toggleBtnGroup}
          >
            <ToggleButton
              value="medicalHistory"
              aria-label="medical history"
              className={styles.toggleBtn}
              disableRipple
            >
              Medical History
            </ToggleButton>
            <ToggleButton
              value="allergies"
              aria-label="allergies"
              className={styles.toggleBtn}
              disableRipple
            >
              Allergies
            </ToggleButton>
            <ToggleButton
              value="medications"
              aria-label="medications"
              className={styles.toggleBtn}
              disableRipple
            >
              Medications
            </ToggleButton>
            <ToggleButton
              value="consultations"
              aria-label="consultations"
              className={styles.toggleBtn}
              disableRipple
            >
              Consultations
            </ToggleButton>
          </ToggleButtonGroup>
          <div className={styles.content}>
            {tab === "medicalHistory" && <MedicalHistory />}
            {tab === "allergies" && <Allergies />}
            {tab === "medications" && <Medications />}
            {tab === "consultations" && <Consultations />}
          </div>
        </div>
      </div>
    </Drawer>
  );
};
